import { DropdownObjectType } from './DropdownObjectType';
import { Employee } from './Employee';
import { Operation } from './Operation';

declare module './Employee' {
  interface Employee {
    laborAccountingCoefficient?: number;
  }
}

export interface ActualOperation {
  id: number | string;
  key?: string;
  operation: Operation;
  volume: string;
  measure?: DropdownObjectType;
  plannedEffort?: number;
  employees: Employee[];
  comment: string;
  generatedID: boolean;
  changed: boolean;
}
